import config from '../config'
// links file to allow one place to change url.

export default {
    whatIsVerifiedUtr: `https://support.${config.siteBaseUrl}/support/solutions/articles/9000154588-what-is-verified-utr-`,
    support: `https://support.${config.siteBaseUrl}/`,
};
